import React from "react";

const parseDistribution = (items) => {
  function resolveDistribution(data) {
    return {
      type: data?.distributionType,
      name: data?.name,
      value: data?.value,
      mean: data?.mean,
      sigma: data?.sigma,
      min: data?.min,
      max: data?.max,
      likely: data?.likely,
    };
  }
  return resolveDistribution(items);
};

export default parseDistribution;
